<template lang="pug">
    div(style="border:0px solid;")
        div(class="" style="border:0px solid; margin-left: 12px;")
            ThemesToolbar
        //- div(class="stock-card-placeholder")
            //- StockCard(v-for="(stock, index) in objectsOnPage" :key="index" :stock="stock" class="mr-6 mb-6")
</template>

<script>
import { mapMutations } from 'vuex';
import ThemesToolbar from './ThemesToolbar.vue';
// import StockCard from './StockCard.vue';

export default {
    name: 'HomeSection',
    components: {
        ThemesToolbar,
        // StockCard
    },
    // data() {
    //     return {
    //         objectsOnPage: []
    //     };
    // }
    methods: {
        ...mapMutations([
            'setShowStockCards'
        ])
    },
    mounted() {
        this.setShowStockCards(true);

        const urlParams = new URLSearchParams(window.location.search);

        // console.log(urlParams.get('tab'));
        // console.log(urlParams.get('stock_id'));
        // console.log(urlParams.get('period'));

        if(urlParams.get('tab') !== null) {
            if(urlParams.get('tab') === '1' && urlParams.get('period') !== null) {
                this.$router.push({ name: 'landing-page.stock-detail', params: { stock_id: urlParams.get('stock_id') }, query: { tab: urlParams.get('tab'), period: urlParams.get('period') } });
            } else if(urlParams.get('tab') === '2') {
                this.$router.push({ name: 'landing-page.stock-detail', params: { stock_id: urlParams.get('stock_id') }, query: { tab: urlParams.get('tab') } });
            }
        }
    },
    beforeDestroy() {
        this.setShowStockCards(false);
    }
}
</script>

<style scoped>
/* .stock-card-placeholder {
    overflow-y: scroll;
    overflow-x: hidden;
    width: 680px;
    height: calc(100vh - 170px);
}

@media only screen and (min-width: 1255px) and (max-width: 1575px) {
    .stock-card-placeholder {
        width: 1000px;
    }
}

@media only screen and (min-width: 1575px) and (max-width: 1905px) {
    .stock-card-placeholder {
        width: 1320px;
    }
}

@media only screen and (min-width: 1905px) {
    .stock-card-placeholder {
        width: 1650px;
    }
} */
</style>
